export default "__VITE_ASSET__wGdNpUT9__"